<template>

 <section v-if='news_list.length!=0' id="noticias" class="secciones seccion-blanca text-center">
      <div class="container">
          <h1><strong>Tu Comunidad</strong></h1>
        <p>Un espacio para los emprendedores.</p>        
        <router-link :to="'/comunidad'" class="btn-al btn-al-lg btn-al-celeste-solid btn-secciones"><span>Ver Todas</span></router-link>
        <div class="row">

          <div class="col-lg-6" v-for="(item, index) in news_list" :key="index">
                <div class="noticias">
                  <router-link :to="'/comunidad/'+item.id_news" class="noticias-foto">
                  <img v-bind:src='imgPreUrl+ item.url_main_image +"x320.jpg"' v-bind:alt='item.title_news_es' class="imagen-cover">
                  </router-link>
                  <div class="noticias-contenido">
                    <div class="noticias-fecha"><strong>{{ item.date_new | esDate }}</strong></div>
                    <div class="noticias-titulo"><h2><strong>{{ item.title_news_es  }}</strong></h2></div>
                    <div class="noticias-texto"><p>{{ (item.desc_news_es).substring(0, 70)+"..."  | striphtml }}</p></div>
                  </div>
                  <router-link :to="'/comunidad/'+item.id_news" class="btn-al btn-al-sm btn-al-celeste-solid noticias-boton">SEGUIR LEYENDO</router-link>
                </div>
              </div>
                  
      </div>
     </div>
  </section>


</template>

<script>
import axios from "axios";
import { config_settings } from '../../config.js';

//HTTP ERROR STATUS
  const NOT_FOUND = 404;
  const BAD_REQUEST = 400;
  const UNAUTHORIZED = 401;
  const INTERNAL_SERVER_ERROR = 500;

  axios.interceptors.response.use(function (response) { return response; }, 
  function (error) {
    
    if(error.message === 'Network Error'){
      toastr.error("No se puede conectar con el servidor. Verifique su conexión a internet",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
    }
    else if(error.response.status === UNAUTHORIZED){
      if(error.response.data.message === "Access is denied"){
         toastr.error("Usted no tiene los provilegios para acceder a esta sección",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
      }
      else {
        return Promise.reject(error);
      }
    }
    else {
      return Promise.reject(error);
    }
});

export default {
  name: "News",
  data() {
    return {
      imgPreUrl : config_settings.PHOTO_SERVER_URL+'/',
      news_list: []
    };
  },
  methods: {
    obtener_noticias(){
        axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/news')
           .then(response => {
             this.news_list = response.data.news;
             if(this.news_list.length>4){
              this.news_list.pop()
             }
             
           })
           .catch(error => {
           
             //this.lenguage == 1 ? this.mensaje_prev="Lo sentimos, no hay noticias para mostrar." : this.mensaje_prev="Sorry, there is no news to show.";
           })
    }
  },
  //manadatory function called from cardTemplate  
  created() {
    this.obtener_noticias();
  }
}
</script>

<style>
.best-products {
  margin-bottom: 10px;
}

#cotizacion {
  padding: 0px;
}
</style>